import {RawAxiosResponseHeaders, ResponseType} from 'axios';

import {CancelToken} from '../../helpers/utilities/asyncCancelHelpers';

export enum RequestMethodsEnum {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
}

export type ResponseHeaders = RawAxiosResponseHeaders;

export interface HttpResponse {
  status: number;
  headers: ResponseHeaders;
  data: unknown;
}

export interface HttpHeaders {
  [T: string]: string;
}

export interface HttpErrorHandlers {
  onUnauthorized: () => void;
  onSessionTimeout: () => void;
  onSessionsMaxReached: () => void;
}

export interface ServerResponseInfo {
  headers: ResponseHeaders;
}

export interface HttpSendOptions {
  cancelToken?: CancelToken;
  signal?: AbortSignal;
  headers?: HttpHeaders;
  errorHandlers?: HttpErrorHandlers;
  onProgressChanged?: (event: ProgressEvent) => void;
  onResponseReceived?: (info: ServerResponseInfo) => void;
  timeout?: number;
  skipBaseUrl?: boolean;
  responseType?: ResponseType;
}

export interface HttpFullSendOptions extends HttpSendOptions {
  method: RequestMethodsEnum;
  path: string;
  body?: unknown;
  responseType?: ResponseType;
}
